(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3448],{

/***/ 51487:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/verification-agreement",
      function () {
        return __webpack_require__(36822);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Anchor(_param) {
    var target = _param.target, rel = _param.rel, isHash = _param.isHash, href = _param.href, rest = _objectWithoutProperties(_param, [
        "target",
        "rel",
        "isHash",
        "href"
    ]);
    var props = _objectSpread({}, rest);
    //const isInternalLink = rest.href.charAt(0) === '/'
    //const hasHash = props.href.includes('#') && isInternalLink
    props.target = isHash ? "" : target !== null && target !== void 0 ? target : "_blank";
    props.rel = isHash ? "" : rel !== null && rel !== void 0 ? rel : "noopener noreferrer";
    // Add path prefix
    if (href && href.startsWith("/") && !href.startsWith("//") && !href.startsWith("/tidbcommunity")) {
        href = "/tidbcommunity" + href;
    }
    props.href = href;
    var _children;
    var children = (_children = props.children) !== null && _children !== void 0 ? _children : props.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, props, {
        children: children
    }));
};


/***/ }),

/***/ 36822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ verification_agreement_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/pages/docs/layout/layout.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n\n  h1,\n  h2 {\n    color: ",
        ";\n  }\n\n  h1 {\n    margin: 4rem 0 2rem;\n    text-align: center;\n  }\n\n  h2 {\n    margin: 2rem 0 1rem;\n  }\n\n  ol {\n    list-style: none;\n  }\n\n  > ol {\n    padding-left: 0;\n  }\n\n  li {\n    margin-bottom: 1rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), mixins/* responsive */.jW(), colors.F2, colors.F1);

// EXTERNAL MODULE: ./src/layouts/index.js + 12 modules
var layouts = __webpack_require__(70230);
;// CONCATENATED MODULE: ./src/pages/docs/layout/Layout.component.js




var Layout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* CoreLayout */.N, {
        hasMargin: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: children
        })
    });
};
/* harmony default export */ var Layout_component = (Layout);

;// CONCATENATED MODULE: ./src/pages/docs/layout/index.js


// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
;// CONCATENATED MODULE: ./src/pages/docs/verification-agreement.page.js





var Page = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: "\u8BA4\u8BC1\u670D\u52A1\u534F\u8BAE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_component, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "TiDB Community \u8BA4\u8BC1\u670D\u52A1\u534F\u8BAE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u6B22\u8FCE\u60A8\u52A0\u5165 TiDB Community \u5E76\u7533\u8BF7\u6210\u4E3A\u4F1A\u5458\uFF01"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "TiDB Community \u8BA4\u8BC1\u670D\u52A1\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u672C\u670D\u52A1\u201D\uFF09\u662F\u5317\u4EAC\u5E73\u51EF\u661F\u8FB0\u79D1\u6280\u53D1\u5C55\u6709\u9650\u516C\u53F8\uFF08\u7B80\u79F0\u201CPingCAP\u201D\uFF09\u63D0\u4F9B\u7ED9\u60A8\u7684\u4E00\u9879\u7528\u6237\u8D44\u8D28\u5BA1\u6838\u670D\u52A1\u3002\u7531\u60A8\u53D1\u8D77\u7533\u8BF7\uFF0CPingCAP \u6839\u636E\u60A8\u7684\u7533\u8BF7\u53CA\u5176\u63D0\u4EA4\u7684\u8D44\u6599\u548C\u4FE1\u606F\u5BA1\u6838\uFF0C\u5E76\u6839\u636E\u5BA1\u6838\u60C5\u51B5\u786E\u5B9A\u8BA4\u8BC1\u7ED3\u679C\u548C\u8BA4\u8BC1\u4FE1\u606F\u7684\u670D\u52A1\u3002"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "\u4E3A\u4F7F\u7528\u672C\u670D\u52A1\uFF0C\u60A8\u5E94\u5F53\u9605\u8BFB\u5E76\u9075\u5B88\u300ATiDB Community \u8BA4\u8BC1\u670D\u52A1\u534F\u8BAE\u300B\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u672C\u534F\u8BAE\u201D\uFF09\u3001",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: "https://www.pingcap.cn/terms-of-use",
                                children: "\u300APingCAP \u4F7F\u7528\u6761\u6B3E\u300B"
                            }),
                            "\u3001",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                href: "https://www.pingcap.cn/privacy-policy",
                                children: "\u300APingCAP \u9690\u79C1\u653F\u7B56\u300B"
                            }),
                            "\u4EE5\u53CA\u76F8\u5173\u89C4\u5219\u3001\u5236\u5EA6\u7B49\u3002"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\u8BF7\u6CE8\u610F\u672C\u670D\u52A1\u4E0D\u63D0\u4F9B\u7ED9\u672A\u6EE118\u5468\u5C81\u4E4B\u4EBA\uFF0C\u5982\u679C\u60A8\u672A\u6EE118\u5468\u5C81\uFF0C\u8BF7\u4E0D\u8981\u4F7F\u7528\u672C\u670D\u52A1\u3002"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "1. \u534F\u8BAE\u7684\u8303\u56F4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "\u672C\u534F\u8BAE\u4E3A",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                href: "https://www.pingcap.cn/terms-of-use",
                                                children: "\u300APingCAP \u4F7F\u7528\u6761\u6B3E\u300B"
                                            }),
                                            "\u3001",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                href: "https://www.pingcap.cn/privacy-policy",
                                                children: "\u300APingCAP \u9690\u79C1\u653F\u7B56\u300B"
                                            }),
                                            "\u7684\u8865\u5145\u534F\u8BAE\uFF0C\u672C\u534F\u8BAE\u4E0E\u524D\u8FF0\u5185\u5BB9\u51B2\u7A81\u65F6\uFF0C\u4EE5\u672C\u534F\u8BAE\u4E3A\u51C6\u3002"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "2. \u60A8\u7684\u6743\u5229\u4E49\u52A1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "2.1 \u60A8\u53EF\u4EE5\u6839\u636E\u81EA\u8EAB\u9700\u6C42\uFF0C\u5BF9\u60A8\u7684 TiDB Community \u8D26\u53F7\u53D1\u8D77\u8BA4\u8BC1\u5BA1\u6838\u7533\u8BF7\u3002"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "2.1.1 \u82E5\u60A8\u5BF9\u60A8\u7684 TiDB Community \u8D26\u53F7\u53D1\u8D77\u8BA4\u8BC1\u5BA1\u6838\u7533\u8BF7\uFF0C\u8BA4\u8BC1\u5BA1\u6838\u6210\u529F\u540E\uFF0C\u60A8\u6709\u6743\u4EAB\u53D7\u8BA4\u8BC1\u6743\u76CA\uFF0CPingCAP \u5C06\u4E0D\u5B9A\u671F\u8C03\u6574\u8BA4\u8BC1\u6743\u76CA\u5E76\u4E8E\u53D1\u5E03\u540E\u751F\u6548\u3002"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "2.1.2 \u82E5\u60A8\u5BF9\u60A8\u7684 TiDB Community \u8D26\u53F7\u53D1\u8D77\u8BA4\u8BC1\u5BA1\u6838\u7533\u8BF7\uFF0C\u8BA4\u8BC1\u5BA1\u6838\u6210\u529F\u540E\uFF0C\u60A8\u7684 TiDB Community \u8D26\u53F7\u5C06\u4F1A\u5C55\u793A\u8BA4\u8BC1\u6807\u8BC6\u3002"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: "2.1.3 \u60A8\u4F7F\u7528\u8BA4\u8BC1\u6743\u76CA\u65F6\u5E94\u9075\u5B88\u76F8\u5173\u6CD5\u89C4\u3002\u5426\u5219\uFF0CTiDB Community \u53CA PingCAP \u6709\u6743\u4E0D\u7ECF\u901A\u77E5\u968F\u65F6\u89C6\u884C\u4E3A\u60C5\u8282\u5BF9\u60A8\u7684\u8D26\u53F7\u91C7\u53D6\u9650\u5236\u3001\u505C\u6B62\u4F7F\u7528\u8BA4\u8BC1\u6743\u76CA\u7B49\u63AA\u65BD\u3002"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "2.2 \u60A8\u5E94\u4FDD\u8BC1\u63D0\u4F9B\u7ED9 PingCAP \u7684\u6240\u6709\u8D44\u6599\u548C\u4FE1\u606F\u662F\u771F\u5B9E\u3001\u5408\u6CD5\u3001\u51C6\u786E\u7684\uFF0C\u4E0D\u4FB5\u72AF\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u5229\u3002\u4EFB\u4F55\u8D44\u6599\u548C\u4FE1\u606F\u7684\u53D8\u66F4\u5C06\u53EF\u80FD\u5F71\u54CD\u8BA4\u8BC1\u7ED3\u679C\uFF0C\u60A8\u5E94\u5F53\u5728\u8D44\u6599\u548C\u4FE1\u606F\u53D8\u66F4\u65F6\u53CA\u65F6\u63D0\u51FA\u8865\u5145\u8BA4\u8BC1\u7533\u8BF7\u3002"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    "2.3 \u60A8\u4FDD\u8BC1\u60A8\u6709\u6743\u5C06\u76F8\u5173\u8D44\u6599\u548C\u4FE1\u606F\u63D0\u4EA4\u7ED9PingCAP\u4EE5\u6309\u7167\u672C\u534F\u8BAE\u3001",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                        href: "https://www.pingcap.cn/terms-of-use",
                                                        children: "\u300APingCAP \u4F7F\u7528\u6761\u6B3E\u300B"
                                                    }),
                                                    "\u3001",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                        href: "https://www.pingcap.cn/privacy-policy",
                                                        children: "\u300APingCAP \u9690\u79C1\u653F\u7B56\u300B"
                                                    }),
                                                    "\u7B49\u7EA6\u5B9A\u7684\u65B9\u5F0F\u52A0\u4EE5\u4F7F\u7528\u3002\u60A8\u4FDD\u8BC1\u8BE5\u7B49\u884C\u4E3A\u4E0D\u8FDD\u53CD\u60A8\u4E0E\u7B2C\u4E09\u65B9\u4E4B\u95F4\u7684\u7EA6\u5B9A\u3001\u60A8\u5BF9\u7B2C\u4E09\u65B9\u505A\u51FA\u7684\u627F\u8BFA\u6216\u5176\u4ED6\u60A8\u5E94\u9075\u5B88\u7684\u89C4\u7AE0\u3001\u5236\u5EA6\uFF0C\u5E76\u4FDD\u8BC1\u60A8\u7684\u8BE5\u7B49\u884C\u4E3A\u4E0D\u4F1A\u7ED9PingCAP\u62DB\u81F4\u7B2C\u4E09\u65B9\u5F02\u8BAE\u6216\u7EA0\u7EB7\u3002"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "2.4 \u60A8\u540C\u610F\u5E76\u6388\u6743 PingCAP \u5BF9\u60A8\u63D0\u4EA4\u7684\u8D44\u6599\u548C\u4FE1\u606F\u8FDB\u884C\u7504\u522B\u6838\u5B9E\uFF0CPingCAP \u6709\u6743\u51FA\u4E8E\u8BA4\u8BC1\u5BA1\u6838\u4E4B\u5FC5\u8981\u67E5\u9605\u3001\u4F7F\u7528\u53CA\u4FDD\u5B58\u4E0A\u8FF0\u8D44\u6599\u53CA\u4FE1\u606F\uFF0C\u5E76\u6709\u6743\u4E0E\u60A8\u5C31\u8BA4\u8BC1\u5BA1\u6838\u4E8B\u5B9C\u8FDB\u884C\u8054\u7CFB\u3002"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "3. TiDB Community \u7684\u6743\u5229\u4E49\u52A1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "3.1 PingCAP \u5C0A\u91CD\u5E76\u4FDD\u62A4\u60A8\u7684\u4FE1\u606F\uFF0CPingCAP \u5C06\u4F1A\u91C7\u53D6\u5408\u7406\u7684\u63AA\u65BD\u4FDD\u62A4\u60A8\u6240\u63D0\u4EA4\u7684\u4E00\u5207\u8D44\u6599\u53CA\u4FE1\u606F\u3002\u9664\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u53CA\u672C\u534F\u8BAE\u7EA6\u5B9A\u7684\u60C5\u5F62\u5916\uFF0C\u672A\u7ECF\u60A8\u7684\u8BB8\u53EF PingCAP \u4E0D\u4F1A\u5411\u5176\u4ED6\u7B2C\u4E09\u65B9\u516C\u5F00\u3001\u900F\u9732\u4E0A\u8FF0\u8D44\u6599\u53CA\u4FE1\u606F\u3002\u5728\u672C\u534F\u8BAE\u8BB8\u53EF\u7684\u8303\u56F4\u5185\uFF0CPingCAP \u4F1A\u5BF9\u76F8\u5173\u8D44\u6599\u53CA\u4FE1\u606F\u91C7\u7528\u4E13\u4E1A\u52A0\u5BC6\u5B58\u50A8\u4E0E\u4F20\u8F93\u65B9\u5F0F\u8FDB\u884C\u4F20\u8F93\u53CA\u4F7F\u7528\uFF0C\u4EE5\u4FDD\u969C\u60A8\u7684\u4FE1\u606F\u5B89\u5168\u3002"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "3.2 \u4E3A\u4FDD\u969C TiDB Community \u8BA4\u8BC1\u670D\u52A1\u7684\u89C4\u8303\u6709\u5E8F\uFF0CPingCAP \u6709\u6743\u9488\u5BF9\u7528\u6237\u7684\u4E0D\u540C\u8BA4\u8BC1\u9700\u6C42\u5236\u5B9A\u4E0D\u540C\u7684\u8BA4\u8BC1\u5BA1\u6838\u6807\u51C6\u53CA\u8981\u6C42\uFF0C\u5E76\u6709\u6743\u5728\u5FC5\u8981\u65F6\u5BF9\u76F8\u5173\u6807\u51C6\u53CA\u8981\u6C42\u8FDB\u884C\u4FEE\u6539\u3002"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "3.3 PingCAP \u6709\u6743\u6839\u636E\u7528\u6237\u63D0\u4EA4\u7684\u8D44\u6599\u53CA\u4FE1\u606F\u5224\u65AD\u3001\u51B3\u5B9A\u5BA1\u6838\u7ED3\u679C\u3002PingCAP \u6839\u636E\u5BA1\u6838\u7ED3\u679C\u5F00\u901A\u76F8\u5E94\u7684\u9AD8\u7EA7\u529F\u80FD\u6216\u9AD8\u7EA7\u6743\u9650\u7684\u7533\u8BF7\u3002"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "4. \u8BA4\u8BC1\u670D\u52A1\u89C4\u8303"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    "4.1 \u8BA4\u8BC1\u6D41\u7A0B",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "\u60A8\u5728\u5B8C\u6210\u5728\u7EBF\u7533\u8BF7\u53CA\u8D44\u6599\u63D0\u4EA4\u6D41\u7A0B\uFF0CPingCAP \u4F1A\u57283\u4E2A\u5DE5\u4F5C\u65E5\u5185\u5C55\u5F00\u8BA4\u8BC1\u5BA1\u6838\u5DE5\u4F5C\uFF0C\u60A8\u5E94\u79EF\u6781\u914D\u5408 PingCAP \u7684\u5BA1\u6838\u9700\u6C42\uFF0C\u5E76\u6709\u6743\u968F\u65F6\u4E86\u89E3\u3001\u67E5\u8BE2\u5BA1\u6838\u8FDB\u5EA6\u3002"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    "4.2 \u8BA4\u8BC1\u89C4\u5219",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "4.2.1 \u60A8\u7406\u89E3\u5E76\u540C\u610F\uFF1ATiDB Community \u8BA4\u8BC1\u670D\u52A1\u5185\u5BB9\u4EC5\u9650\u4E8E\u5BF9\u60A8\u63D0\u4EA4\u7684\u8D44\u6599\u53CA\u4FE1\u606F\u8FDB\u884C\u5408\u7406\u3001\u8C28\u614E\u7684\u5F62\u5F0F\u5BA1\u67E5\uFF0C\u4F46\u5728 PingCAP \u7684\u5408\u6CD5\u6743\u9650\u548C\u5408\u7406\u80FD\u529B\u8303\u56F4\u5185\uFF0CPingCAP \u65E0\u6CD5\u5B9E\u8D28\u5BA1\u67E5\u60A8\u7684\u5B9E\u9645\u7ECF\u8425\u3001\u8FD0\u8425\u4EE5\u53CA\u63A8\u5E7F\u7B49\u884C\u4E3A\uFF0C\u5E76\u4E0D\u4E3A\u6B64\u63D0\u4F9B\u4EFB\u4F55\u62C5\u4FDD\u3002"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    "4.2.2 PingCAP \u6709\u6743\u6838\u5B9E\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4EE5\u4E0B\u5185\u5BB9\uFF1A",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                children: "4.2.2.1 \u60A8\u6240\u670D\u52A1\u7684\u516C\u53F8\u6216\u4F01\u4E1A\u662F\u5426\u62E5\u6709\u5408\u6CD5\u4E3B\u4F53\u8D44\u8D28\uFF1B"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                children: "4.2.2.2 \u8D26\u53F7\u4E3B\u4F53\u8EAB\u4EFD\uFF0C\u4EE5\u53CA\u76F8\u5173\u4EFB\u804C\u4FE1\u606F\uFF1B"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                children: "4.2.2.3 \u5176\u4ED6 PingCAP \u8BA4\u4E3A\u9700\u8981\u5BA1\u6838\u7684\u5185\u5BB9\u3002"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "5. \u77E5\u8BC6\u4EA7\u6743"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "PingCAP \u662F\u672C\u670D\u52A1\u53CA\u5176\u76F8\u5173\u4EA7\u54C1\u7684\u77E5\u8BC6\u4EA7\u6743\u6743\u5229\u4EBA\u3002\u672C\u670D\u52A1\u53CA\u5176\u76F8\u5173\u4EA7\u54C1\u7684\u4E00\u5207\u8457\u4F5C\u6743\u3001\u5546\u6807\u6743\u3001\u4E13\u5229\u6743\u3001\u5546\u4E1A\u79D8\u5BC6\u7B49\u77E5\u8BC6\u4EA7\u6743\uFF0C\u4EE5\u53CA\u76F8\u5173\u7684\u6240\u6709\u4FE1\u606F\u5185\u5BB9\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6587\u5B57\u3001\u56FE\u7247\u3001\u754C\u9762\u8BBE\u8BA1\u3001\u7248\u9762\u6846\u67B6\u7B49\uFF09\u5747\u53D7\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u76F8\u5173\u56FD\u9645\u6761\u7EA6\u7684\u4FDD\u62A4\uFF0C\u7531 PingCAP \u4EAB\u6709\uFF0C\u672C\u534F\u8BAE\u53E6\u884C\u7EA6\u5B9A\u3001\u6216\u6309\u7167\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7531\u5176\u4ED6\u6743\u5229\u4EBA\u4EAB\u6709\u7684\u9664\u5916\u3002"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "6. \u6CD5\u5F8B\u8D23\u4EFB"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "6.1 \u5982\u679C PingCAP \u53D1\u73B0\u6216\u6536\u5230\u4ED6\u4EBA\u4E3E\u62A5\u6216\u6295\u8BC9\u60A8\u8FDD\u53CD\u672C\u534F\u8BAE\u7EA6\u5B9A\u7684\uFF0CPingCAP \u6709\u6743\u4E0D\u7ECF\u901A\u77E5\u968F\u65F6\u89C6\u884C\u4E3A\u60C5\u8282\u5BF9\u60A8\u7684\u8D26\u53F7\u5904\u4EE5\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7EC8\u6B62\u672C\u670D\u52A1\u8D44\u8D28\u5BA1\u6838\u3001\u8981\u6C42\u60A8\u8865\u5145\u8D44\u8D28\u5BA1\u67E5\u8D44\u6599\u3001\u8981\u6C42\u60A8\u4FEE\u6539\u8BA4\u8BC1\u4FE1\u606F\u3001\u5F3A\u5236\u4FEE\u6539\u8D26\u53F7\u540D\u79F0\u53CA\u8BA4\u8BC1\u4FE1\u606F\u76F4\u81F3\u53D6\u6D88\u8BA4\u8BC1\u7B49\u63AA\u65BD\u3002"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "6.2 \u60A8\u7406\u89E3\u5E76\u540C\u610F\uFF0C\u56E0\u60A8\u8FDD\u53CD\u672C\u534F\u8BAE\u6216\u76F8\u5173\u670D\u52A1\u6761\u6B3E\u7684\u89C4\u5B9A\uFF0C\u5BFC\u81F4\u7B2C\u4E09\u65B9\u4E3B\u5F20\u7684\u4EFB\u4F55\u7D22\u8D54\u3001\u8981\u6C42\u6216\u635F\u5931\uFF0C\u60A8\u5E94\u5F53\u72EC\u7ACB\u627F\u62C5\u8D23\u4EFB\uFF1BPingCAP \u56E0\u6B64\u906D\u53D7\u635F\u5931\u7684\uFF0C\u60A8\u4E5F\u5E94\u5F53\u4E00\u5E76\u8D54\u507F\u3002"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "7. \u5176\u4ED6"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "7.1 \u60A8\u4F7F\u7528\u672C\u670D\u52A1\u5373\u89C6\u4E3A\u60A8\u5DF2\u9605\u8BFB\u5E76\u540C\u610F\u53D7\u672C\u534F\u8BAE\u7684\u7EA6\u675F\u3002PingCAP \u6709\u6743\u5728\u5FC5\u8981\u65F6\u4FEE\u6539\u672C\u534F\u8BAE\u6761\u6B3E\u3002\u60A8\u53EF\u4EE5\u5728\u76F8\u5173\u670D\u52A1\u9875\u9762\u67E5\u9605\u6700\u65B0\u7248\u672C\u7684\u6761\u6B3E\u3002\u672C\u534F\u8BAE\u6761\u6B3E\u53D8\u66F4\u540E\uFF0C\u5982\u679C\u60A8\u7EE7\u7EED\u4F7F\u7528 TiDB Community \u8BA4\u8BC1\u670D\u52A1\uFF0C\u5373\u89C6\u4E3A\u60A8\u5DF2\u63A5\u53D7\u4FEE\u6539\u540E\u7684\u534F\u8BAE\u3002\u5982\u679C\u60A8\u4E0D\u63A5\u53D7\u4FEE\u6539\u540E\u7684\u534F\u8BAE\uFF0C\u5E94\u5F53\u505C\u6B62\u4F7F\u7528 TiDB Community \u8BA4\u8BC1\u670D\u52A1\u3002"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "7.2 \u672C\u534F\u8BAE\u7684\u6210\u7ACB\u3001\u751F\u6548\u3001\u5C65\u884C\u3001\u89E3\u91CA\u53CA\u7EA0\u7EB7\u89E3\u51B3\uFF0C\u9002\u7528\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5927\u9646\u5730\u533A\u6CD5\u5F8B\uFF08\u4E0D\u5305\u62EC\u51B2\u7A81\u6CD5\uFF09\u5E76\u7531\u5317\u4EAC\u5E02\u6D77\u6DC0\u533A\u4EBA\u6C11\u6CD5\u9662\u4E13\u5C5E\u7BA1\u8F96\u3002"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "\u5317\u4EAC\u5E73\u51EF\u661F\u8FB0\u79D1\u6280\u53D1\u5C55\u6709\u9650\u516C\u53F8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "2022\u5E748\u670810\u65E5"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var verification_agreement_page = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(51487); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);